import { ApplicationElement, html } from '@beunity/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';
import '@beunity/lit-components/components/avatar/element.js';
import '@beunity/lit-components/components/icon/element.js';
import '@beunity/lit-components/components/timeago/element.js';

/**
 * List item with avatar and time
 *
 * @prop pictureType - (options:  avatar, picture)
 * @prop picture - url to image (optional)
 * @prop name - for avatar initials (optional)
 * @prop href - anchor href
 * @prop text - list main title
 * @prop hint - list hint (optional)
 * @prop details - list details (optional)
 * @prop timeago - timestamp
 */
export default class ListItem2 extends ApplicationElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    text: { type: String },
    hint: { type: String },
    details: { type: String },
    href: { type: String },
    timeago: { type: Date },
    pictureType: { type: String },
    picture: { type: String },
    name: { type: String },
  };

  /** @internal */
  get imageOrPlaceholder() {
    return this.picture ? this.renderPicture() : this.renderPlaceholder();
  }

  renderAvatar() {
    return html`<ef-avatar
      picture=${ifDefined(this.picture)}
      name="${this.name}"
      layout="sm"></ef-avatar>`;
  }

  renderPicture() {
    return html`
      <img src="${this.picture}" class="img"></img>
    `;
  }

  renderPlaceholder() {
    return html` <ef-icon name="image"></ef-icon> `;
  }

  renderHint() {
    return html`<span class="type">${this.hint}</span>`;
  }

  renderDetails() {
    return html`<span class="details">${this.details}</span>`;
  }

  render() {
    return html`
      <a href="${this.href}">
        ${this.pictureType === 'avatar' ? this.renderAvatar() : ''}
        ${this.pictureType === 'picture' ? this.imageOrPlaceholder : ''}
        <div class="content">
          <h3 class="title">${this.text} ${this.hint && this.renderHint()}</h3>
          ${this.details && this.renderDetails()}
        </div>
        <div class="info">
          <ef-timeago
            timestamp="${this.timeago}"
            class="published_at"></ef-timeago>
        </div>
      </a>
    `;
  }
}

customElements.get('bu-list-item-2') ||
  customElements.define('bu-list-item-2', ListItem2);
